import React, { useState, useEffect } from "react";

import { Link } from "react-router-dom";

// Icons imports
import { HiArrowNarrowLeft } from "react-icons/hi";
import { HiArrowNarrowRight } from "react-icons/hi";

// Scss imports
import css from "./NavigationBar.module.scss";

// redux
import { useSelector } from "react-redux";
interface NavigationBarProps {
  type?: string;
  onClickEvent?: any;
  notArchivedPapers?: any;
}

const NavigationBar: React.FC<NavigationBarProps> = ({
  type,
  onClickEvent,
  notArchivedPapers,
}) => {
  const [currentUserRole, setCurrentUserRole] = useState("");
  const currentUserData = useSelector(
    (state: any) => state.currentUser.currentUserData
  );

  useEffect(() => {
    if (currentUserData) {
      setCurrentUserRole(currentUserData.role);
    }
  }, [currentUserData]);

  return (
    <nav className={css.navbar}>
      <div className={`${css.navbarContainer} ${css.container}`}>
        <input className={css.navInput} type="checkbox" name="" id="" />
        <div className={css.hamburgerLines}>
          <span className={`${css.line} ${css.line1}`}></span>
          <span className={`${css.line} ${css.line2}`}></span>
          <span className={`${css.line} ${css.line3}`}></span>
        </div>
        {type === "notArchived" ? (
          <div className={css.notArchivedContainer}>
            <Link to="/">
              <div>
                <HiArrowNarrowLeft className={css.icon} />
                <p>Назад на деловодник</p>
              </div>
            </Link>
            {notArchivedPapers && notArchivedPapers.length > 0 && (
              <div className={css.orangeText} onClick={onClickEvent}>
                <p>Настави архивирање</p>
                <HiArrowNarrowRight className={css.icon} />
              </div>
            )}
          </div>
        ) : (
          <ul className={`${css.menuItems}`}>
            <li>
              <Link to="/">Деловодник</Link>
            </li>
            <li>
              <Link to="/archive">Архивска књига</Link>
            </li>
            <li>
              <Link to="/categories">Листа категорија</Link>
            </li>
            <li>
              <Link to="/processors">Обрађивачи</Link>
            </li>
            <li>
              <Link to="/user-panel">Кориснички налог</Link>
            </li>
            <li>
              <Link to="/patterns">Обрасци</Link>
            </li>
            {currentUserRole.length > 1 && currentUserRole === "admin" && (
              <li>
                <Link to="/all-users">Сви корисници</Link>
              </li>
            )}
            <li>
              <Link to="/files/korisnicko_uputstvo" target="_blank" download>
                Корисничко упутство
              </Link>
            </li>
          </ul>
        )}
      </div>
    </nav>
  );
};

export default NavigationBar;
